import { Component } from '@angular/core';

@Component({
  selector: 'uni-filter-bar',
  templateUrl: './uni-filter-bar.component.html',
  styleUrls: ['./uni-filter-bar.component.scss'],
})
export class UniFilterBarComponent {}
